export default __webpack_public_path__ + "static/media/EmeraldIcon.06ec843f.svg";